/** Consent cookie for optional analytics — essential session cookies are unaffected. */
const CONSENT_COOKIE = 'unity_cookie_consent';

export type CookieConsent = {
  /** Optional product analytics. Essential session cookies do not need this flag. */
  analytics: boolean;
  decidedAt: string;
};

export const readCookieConsent = (): CookieConsent | null => {
  if (typeof document === 'undefined') return null;
  try {
    const match = document.cookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith(`${CONSENT_COOKIE}=`));
    if (!match) return null;
    const raw = decodeURIComponent(match.slice(CONSENT_COOKIE.length + 1));
    const parsed = JSON.parse(raw) as Partial<CookieConsent>;
    if (typeof parsed.analytics !== 'boolean') return null;
    return {
      analytics: parsed.analytics,
      decidedAt: typeof parsed.decidedAt === 'string' ? parsed.decidedAt : new Date().toISOString(),
    };
  } catch {
    return null;
  }
};

export const setCookieConsent = (input: { analytics: boolean }): void => {
  const consent: CookieConsent = {
    analytics: input.analytics,
    decidedAt: new Date().toISOString(),
  };
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(JSON.stringify(consent))}; path=/; expires=${expires.toUTCString()}; SameSite=Lax${secure}`;
};

export const clearCookieConsent = (): void => {
  document.cookie = `${CONSENT_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
};

export const hasAnalyticsConsent = (): boolean => readCookieConsent()?.analytics === true;

export const COOKIE_CONSENT_NAME = CONSENT_COOKIE;
